import ProxyBase from '../../../core/proxies/ProxyBase'

class CartAndOrderProxy extends ProxyBase {
  getCartItems() {
    return this.get('CartAndOrder/CartItems')
  }

  delCartItem(params) {
    return this.delete('CartAndOrder/CartItems', params)
  }

  postOrder(params) {
    return this.post('CartAndOrder/Orders', params)
  }

  postOrderZero(params) {
    return this.post('CartAndOrder/Orders/ZeroAmount', params)
  }

  getDiscount(params) {
    return this.get('DiscountAndVoucher/Discounts', params)
  }

  getVoucher(params) {
    return this.get('DiscountAndVoucher/Voucher', params)
  }

  getUserPricingPackages(params) {
    return this.get('UserManagement/UserPricingPackages', params)
  }

  getUserProfile(params) {
    return this.get('UserManagement/UserProfile', params)
  }

  getBankTransferInfo(params) {
    return this.get('Transaction/BankTransferInfo', params)
  }

  getSimilarCompanies(params) {
    return this.get('CartAndOrder/SimilarCompanies', params)
  }

  getMostPopularCompanies(params) {
    return this.get('CartAndOrder/MostPupularCompanies', params)
  }

  getTerms(params) {
    return this.get('Payment/TermsAndConditions', params)
  }
}

export default new CartAndOrderProxy()
